export default __webpack_public_path__ + "static/3p9-parametric-map-05ad611b509936989a25186a9630d7e1.png";